import { Box, Stack, Typography } from "@mui/material";
import StatusChip from "../statusChip/statusChip.component";
import {
  STATUS_COLORS,
  STATUS_TRANSLATIONS,
} from "../../utils/statusConstants";
import { formattedDate } from "../../utils/dateUtils";
import { Block, Check, Delete } from "@mui/icons-material";
import FormActionButton from "../buttons/formActionButton.component";
import { useIsMobile } from "../../hook/useIsMobile";

const UserActionPanel = ({ user, onBlock, onDelete, isBlocked }) => {
  const isMobile = useIsMobile();
  const status = user?.status;
  const registrationDate = formattedDate(user?.date_joined);

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      alignItems="center"
      justifyContent="space-between"
      marginBottom={4}
      gap={4}
    >
      <Box
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        bgcolor="#f6f6f6"
        height={isMobile ? "auto" : "40px"}
        p={2}
        alignItems={isMobile ? "flex-start" : "center"}
        gap={isMobile ? 4 : 1.5}
        width="100%"
      >
        <Typography fontWeight="bold" fontSize="12px" component="span">
          Stato:{" "}
          {
            <StatusChip
              status={STATUS_TRANSLATIONS[status]}
              colors={STATUS_COLORS}
            />
          }
        </Typography>
        <Typography fontWeight="bold" fontSize="12px">
          Terreni: -
        </Typography>
        <Typography fontWeight="bold" fontSize="12px">
          Iscrizione: {registrationDate}
        </Typography>
      </Box>
      <Stack
        spacing={2}
        direction={isMobile ? "column" : "row"}
        width="100%"
        justifyContent={isMobile ? "center" : "end"}
      >
        <FormActionButton
          startIcon={isBlocked ? <Check /> : <Block />}
          onClick={onBlock}
          label={isBlocked ? "Attiva utente" : "Blocca utente"}
        />
        <FormActionButton
          startIcon={<Delete />}
          onClick={onDelete}
          label="Elimina utente"
          color="error"
        />
      </Stack>
    </Box>
  );
};

export default UserActionPanel;
